/**
 * Set a cookie.
 *
 * @param cname
 * @param cvalue
 * @param exdays
 */
function setCookie(cname, cvalue, exdays) {
    let d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    let expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function deleteCookie(cname) {
    document.cookie = cname + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
}

/**
 * Save the latest service page the user has visited.
 */
export function latestService() {
    // When a user visits a service page set a localStorage Item.
    let myStorage = window.localStorage,
        serviceList = myStorage['service-list'];

    // Set serviceSlug
    const body = document.querySelector('body');
    const searchResult = document.querySelector('.js-service-search__result-data');
    const bodyData = body && body.getAttribute('data-service');
    const searchResultData = searchResult && searchResult.getAttribute('data-service');
    const serviceSlug = bodyData ? bodyData : searchResultData;

    if (serviceSlug) {
        myStorage.setItem('latest-service', serviceSlug);

        if (serviceList) {
            if (!serviceList.includes(serviceSlug)) {
                serviceList += `,${serviceSlug}`;
                myStorage.setItem('service-list', serviceList);
            }
        } else {
            myStorage.setItem('service-list', serviceSlug);
        }

    }

    const locationResult = document.querySelector('.js-service-search__result-data');
    const locationSlug = locationResult && locationResult.getAttribute('data-location');

    if(locationSlug) {
        setLocationList(locationSlug);
    }

    if(serviceSlug) {
        setSelectedService(serviceSlug);
    }
}

/**
 * Save service in localStorage
 *
 * @param {string} selected_service
 */
function setSelectedService(selected_service) {
    let myStorage = window.localStorage,
        serviceList = myStorage['service-list'];

    myStorage.setItem('latest-service', selected_service);
    setCookie('latest-service', selected_service, 30);

    if (serviceList) {
        if (!serviceList.includes(selected_service)) {
            serviceList += ',' + selected_service;
            myStorage.setItem('service-list', serviceList);
        }
    } else {
        myStorage.setItem('service-list', selected_service);

    }

    window.dataLayer.push({
        'active_interested_service': selected_service,
        'all_interested_services': serviceList.split(","),
        'event': 'serviceSelected'
    });

}

/**
 * Save location list in localStorage
 *
 * @param {string} selected_location
 */
function setLocationList(selected_location) {
    let myStorage = window.localStorage,
        locationList = myStorage ['location-list'];

    // Update the latest location
    setLatestLocation(selected_location);

    // Add the selected location to the location list (or create list)
    if (locationList) {
        if (!locationList.includes( selected_location)) {
            locationList += ',' + selected_location;
            myStorage.setItem('location-list', locationList);
        }
    } else {
        locationList = selected_location;
        myStorage.setItem('location-list', selected_location);

    }

    // Push location list to the datalayer
    window.dataLayer.push({
        'active_interested_location': selected_location,
        'all_interested_locations': locationList.split( "," ),
        'event': 'locationSelected'
    });
}

/**
 * Save the latest service type visited.
 */
export function latestServiceType() {
    let serviceTypeElement = document.querySelector('.js-service-search__result-data, body'),
        serviceType = serviceTypeElement && serviceTypeElement.dataset && serviceTypeElement.dataset.serviceType;

    if (serviceType) {
        // Remove latest service if the service-type changes.
        const currentServiceType = localStorage.getItem('latest-service-type');

        if (currentServiceType !== serviceType) {
            localStorage.removeItem('latest-service');
        }

        localStorage.setItem('latest-service-type', serviceType);
        // We also need to save a cookie so that we can use the value in php (ie. the blog loop)
        setCookie('latest-service-type', serviceType, 30);
    }

    let serviceArchiveSwitchButton = document.getElementById('service-archive-switch'),
        serviceArchiveServiceType = serviceArchiveSwitchButton && serviceArchiveSwitchButton.dataset && serviceArchiveSwitchButton.dataset.serviceType;

    if (serviceArchiveServiceType) {
        serviceArchiveSwitchButton.addEventListener('click', function () {
            localStorage.setItem('latest-service-type', serviceArchiveServiceType);
            setCookie('latest-service-type', serviceArchiveServiceType, 30);
        });
    }
}

/**
 * Save the latest location visited.
 */
export function latestLocation() {
    let locationData = document.querySelector('.js-service-search__result-data'),
        locationSlug = locationData && locationData.getAttribute('data-location');

    if (locationSlug) {
        setLatestLocation(locationSlug);
    }
}

function setLatestLocation(location) {
    let myStorage = window.localStorage;
    myStorage.setItem('latest-location', location);
    // We also need to save a cookie so that we can use the value in php
    setCookie('latest-location', location, 30);
}

export function deleteLatestLocation() {
    let myStorage = window.localStorage;
    myStorage.removeItem('latest-location');
    // We also need to remove the cookie
    deleteCookie('latest-location');
}



// WEBPACK FOOTER //
// ./src/js/cookies-localstorage.js